import { pick } from 'lodash'

const keysToPersist = {
  auth: ['token', 'expiration', 'loggedOut', 'user', 'adminToken', 'adminUserId'],
  addToHome: ['complete'],
}

const persistFn = (state, key) => pick(state, keysToPersist[key])

const transform = {
  in: persistFn,
  out: persistFn,
}

export default {
  whitelist: Object.keys(keysToPersist),
  transforms: [transform],
}



// WEBPACK FOOTER //
// ./src/app/state/persistConfig.js